import React from "react";

// Shared platform attribution footer. Reused across auth + marketing surfaces.
export function PoweredByFooter({ className = "", light = false }) {
  return (
    <p
      data-testid="powered-by-footer"
      className={`text-xs ${light ? "text-mist-300" : "text-muted-foreground"} ${className}`}
    >
      Powered by Nauticus · A platform by Navillus Technologies LLC. ·{" "}
      <a href="/privacy" data-testid="footer-privacy-link" className="underline hover:no-underline">Privacy &amp; Security</a>
    </p>
  );
}
